<template>
  <v-container class="center-container">
    <v-row>
      <v-col cols="6">
        <v-btn
          color="primary"
          dark
          class="boton_largo"
          @click="gotToPage('desmoldeo')"
          >DESMOLDEO</v-btn
        >
      </v-col>
      <v-col cols="6">
        <v-btn
          color="primary"
          dark
          class="boton_largo"
          @click="gotToPage('macheria')"
          >MACHERIA</v-btn
        >
      </v-col>
      <v-col cols="6">
        <v-btn
          color="primary"
          dark
          class="boton_largo"
          @click="gotToPage('moldeo')"
          >MOLDEO</v-btn
        >
      </v-col>
      <v-col cols="6">
        <v-btn
          color="primary"
          dark
          class="boton_largo"
          @click="gotToPage('imf_nave_2')"
          >IMF NAVE 2</v-btn
        >
      </v-col> 
       <v-col cols="6">
        <v-btn
          color="primary"
          dark
          class="boton_largo"
          @click="gotToPage('hornos1y2')"
          >HORNOS 1 Y 2</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "MenuPage",

  data: () => ({}),
  computed: {
    ...mapGetters(["getMaquinas"]),
  },
  methods: {
    ...mapActions(["setMachine", "setTab", "setPieza"]),
    gotToPage(page) {
      this.setMachine(page);
      let maquina = this.getMaquinas.find((e) => e.maquina == page);
      this.$router.push({ path: "/now" });
      this.setTab(1);
    },
  },
};
</script>

<style>
.center-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.boton_largo {
  width: 100%;
  font-size: 180% !important;
  height: 100px !important;
  margin: 10px;
}
</style>
